import styles from './TileList.module.scss';
import { Container } from 'ui/components/4-habitats/Container/Container';
import classNames from 'classnames';
import { TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import { Kicker, KickerProps } from 'ui/components/1-atoms/Kicker/Kicker';
import { TileCard, TileCardProps } from 'ui/components/2-molecules/Card/TileCard/TileCard';
import ColorOptions from 'helpers/types';

export interface TileListProps {
	kicker?: KickerProps;
	items: TileCardProps[];
	bgColor?: ColorOptions;
}

export const TileList: React.FC<TileListProps> = ({ items, kicker, bgColor = 'white' }) => {
	const kickerExists = kicker && (kicker.firstWord || kicker.secondWord);
	return (
		<div className={classNames(styles.TileList, styles[`u-color___${bgColor}`], { [styles[`TileList___withKicker`]]: kicker })}>
			<Container width="Standard">
				<TopLevelGrid container wrap>
					{kickerExists && (
						<TopLevelGridCell desktopWidth="7col" mobileWidth="100">
							<Kicker {...kicker} className={styles.TileList_kicker} />
						</TopLevelGridCell>
					)}
					<TopLevelGridCell desktopWidth="15col" desktopOffset={kickerExists ? null : '2col'} offsetDirection="right" mobileWidth="100">
						{items.map((item, index) => (
							<TileCard noPaddingTop={kickerExists && index === 0} {...item} key={index} />
						))}
					</TopLevelGridCell>
				</TopLevelGrid>
			</Container>
		</div>
	);
};
